import { BENEFICIARYDETAILS } from '../actionTypes';

export const fetchBeneficiaryDetails = (action) => ({
  type: BENEFICIARYDETAILS.FETCH,
  payload: action.payload,
});
